<template>
  <div id="community" class="featured-container ">
    <div class="inner fr-container">
      <div class="content">
        <div class="left">
          <div class="text-content">
            <h2 class="title">As featured in</h2>
            <span class="description">
      It is a long established fact that a reader will be
      distracted by the readable content of a page when
      looking at its layout. The point of using Lorem
      Ipsum is that it has a more-or-less normal.
    </span>
          </div>
          <div class="social-icons-container">
            <div class="social-list">
              <div v-for="(item,index) in networks" :key="index" class="social-item">
                <img :src="item.url" :alt="item.title" class="image">
              </div>
            </div>
          </div>
        </div>
        <img src="../../../assets/images/crystal.png" class="right-image" alt="crystal rocket">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      networks: [
        {
          title: 'telegram',
          url: require('../../../assets/images/telegram.png')
        },
        {
          title: 'twitter',
          url: require('../../../assets/images/twitter.png')
        },
        {
          title: 'game',
          url: require('../../../assets/images/game.png')
        },
        // {
        //   title: 'instagram',
        //   url: require('../../../assets/images/instagram.png')
        // },
        // {
        //   title: 'facebook',
        //   url: require('../../../assets/images/facebook.png')
        // },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.featured-container {
  //position: relative;
  background: black;
  @media only screen and (max-width: 1023px) {
    background: #070A1E;
  }

  .fr-container {
    @media only screen and (max-width: 1023px) {
      padding: 0;
    }
  }

  .content {
    @include space-between;
    background: #070A1E;
    border-radius: 40px;
    padding: 30px 80px 30px 0;
    margin-top: -250px;
    @media only screen and (max-width: 1365px) and (min-width: 1024px) {
      padding: 30px 30px 30px 0;
      margin-top: -150px;
    }
    @media only screen and (max-width: 1023px) {
      margin-top: 0;
      flex-direction: column-reverse;
      justify-content: normal;
    }
    @media only screen and (max-width: 1023px) {
      padding-right: 0;
    }

    .left {
      @media only screen and (max-width: 1023px) {
        width: 100%;
      }
    }
  }

  .text-content {
    padding-left: 83px;
    @media only screen and (max-width: 1365px) and (min-width: 1024px) {
      padding-left: 53px;
    }
    @media only screen and (max-width: 1023px) {
      padding-left: 0;
    }
  }

  .title {
    font-style: normal;
    font-weight: 500;
    font-size: 30px;
    color: $base-color;
    @media only screen and (max-width: 1023px) {
      font-size: 25px;
      text-align: center;
      display: block;
      margin-top: 30px;
    }
  }

  .description {
    margin-top: 20px;
    display: block;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 26px;
    color: #FFFFFF;
    max-width: 514px;
    @media only screen and (max-width: 1365px) and (min-width: 1024px) {
      font-size: 14px;
      line-height: 20px;
      max-width: 350px;
      margin-top: 16px;
    }
    @media only screen and (max-width: 1023px) {
      font-size: 15px;
      line-height: 25px;
      text-align: center;
      margin: 20px auto 0;
      padding: 0 20px;
    }
  }

  .social-icons-container {
    margin-top: 50px;
    background: linear-gradient(270deg, rgba(66, 232, 224, 0.29) 0%, rgba(7, 10, 30, 0) 100%);
    border-bottom-right-radius: 120px;
    border-top-right-radius: 120px;
    padding: 49px 59px 49px 83px;
    width: fit-content;
    @media only screen and (max-width: 1440px) and (min-width: 1024px) {
      padding: 41px 59px 41px 83px;
    }
    @media only screen and (max-width: 1365px) and (min-width: 1024px) {
      padding: 35px 41px 35px 53px;
      margin-top: 30px;
      width: fit-content;
    }
    @media only screen and (max-width: 1023px) {
      padding: 27px 32px 27px 53px;
      margin-top: 21px;
      width: fit-content;
    }
    @media only screen and (max-width: 767px) {
      padding: 27px 32px 27px 20px;
      width: 90%;
    }

    .social-list {
      @include flex;

      .social-item {
        @include center-children;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        border: 1px solid $base-color;
        margin-right: 47px;
        cursor: pointer;
        @media only screen and (max-width: 1440px) and (min-width: 1366px) {
          width: 65px;
          height: 65px;
          margin-right: 35px;
        }
        @media only screen and (max-width: 1365px) and (min-width: 1024px) {
          width: 55px;
          height: 55px;
          margin-right: 30px;
        }
        @media only screen and (max-width: 1023px) {
          width: 35px;
          height: 35px;
          margin-right: 25px;
          img {
            width: 15px;
          }
        }
        @media only screen and (max-width: 767px) {
          margin-right: 15px;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .right-image {
    @media only screen and (max-width: 1650px) and (min-width: 1441px) {
      width: 350px;
    }
    @media only screen and (max-width: 1440px) and (min-width: 1366px) {
      width: 300px;
    }
    @media only screen and (max-width: 1365px) and (min-width: 1024px) {
      width: 250px;
    }
    @media only screen and (max-width: 1023px) {
      width: 250px;
    }
  }
}
</style>